import { render, staticRenderFns } from "./dadutou.vue?vue&type=template&id=1f66338a&scoped=true&"
import script from "./dadutou.vue?vue&type=script&lang=js&"
export * from "./dadutou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f66338a",
  null
  
)

export default component.exports